// pattern: Functional Core

import { type FunctionComponent } from 'preact'
import { html } from 'htm/preact'
import './about.css'
import { NBSP } from '../constants.js'

export const AboutRoute:FunctionComponent = function () {
    return html`<div class="route about">
        <h2>The Colophon</h2>
        <p>
            The easiest way to create${NBSP}
            <a href="https://swagger.io/specification/">Open API specs</a>.
            Create the Open API JSON doc here, then paste it into something
            like <a href="https://heyapi.dev/">heyapi</a>, and just like that
            you've got working typescript.
        </p>

        <h3>Host</h3>

        <p>
            This site is hosted by <a href="https://netlify.com">Netlify</a>.
            ${NBSP}It runs totally in your browser. Nothing touches a server
            after the page loads.
        </p>
    </div>`
}
